import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TranscriptTemplateCreation from "ProgressReportTemplate/routes/TranscriptTemplateCreation";
export default store => ({
  path: "template-config",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
        import(
          /* webpackChunkName: "transcript-chunk" */ "ProgressReportTemplate/modules/ProgressReportTemplateModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReportTemplate",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [TranscriptTemplateCreation(store)],
});
